// Le pagine di conferimento devono nascere in un documento senza script di terzi.
// Un cambio route SPA non può annullare l'instrumentazione già installata.
export const isVccSensitivePath = path => /^\/scf\/creditCardPrograms\/[^/]+\/[^/]+\/virtual-cards\/?$/.test(path)
export const reloadForSensitiveRoute = () => window.location.reload()
